import { put, select } from "redux-saga/effects";

import type { TopicStakeholdersApplySearchCriteriaAction } from "domains/stakeholders/actionTypes";
import { getStakeholdersSearchCriteria } from "domains/stakeholders/selectors";
import { getTmSelectedId } from "domains/transformationMap/selectors";
import { fetchStakeholdersForTopic } from "entities/stakeholders/actions";

export function* applyStakeholdersSearchCriteriaSaga(action: TopicStakeholdersApplySearchCriteriaAction) {
  const searchCriteria: ReturnType<typeof getStakeholdersSearchCriteria> = yield select(getStakeholdersSearchCriteria);
  const tmSelectedId: ReturnType<typeof getTmSelectedId> = yield select(getTmSelectedId);
  const id = action.payload?.topicId ?? tmSelectedId;
  if (!id) {
    return;
  }
  yield put(fetchStakeholdersForTopic({ id, ...searchCriteria }));
}
